import type { ApolloError } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useTypedSelector } from 'src/modules/hooks/useTypedSelector';

import { fetchProfileFailure, profileLoaded } from '../actionCreators';

export const useProfileLoadingActions = ({
  loading,
  error,
}: {
  loading: boolean;
  error: ApolloError | undefined;
}) => {
  const isProfileLoading = useTypedSelector((store) => store.profile.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isProfileLoading && !loading && !error) {
      dispatch(profileLoaded());
    }
    if (!loading && error) {
      dispatch(fetchProfileFailure(error));
    }
  }, [dispatch, error, isProfileLoading, loading]);
};
